require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-aaron-cork.json") })
        }
      }, "path---authors-aaron-cork");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-aaron-cork!./.cache/json/authors-aaron-cork.json
// module id = 1249
// module chunks = 231608221292675